<script>
import _ from 'lodash'

export default {
  props: {
    fields: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      model: {
        valid: false,
        dirty: false,
        fields: _.cloneDeep(this.fields),
        rules: {
          required: [v => !!v || 'This field is Required'],
        },
      },
    }
  },

  watch: {
    fields(newValue) {
      if (newValue) this.model.fields = _.cloneDeep(newValue)
    },
    'model.fields': {
      handler(newValue) {
        const equalValues = _.isEqual(newValue, this.fields)
        this.model.dirty = this.model.dirty || !equalValues
        if (this.model.dirty) {
          setTimeout(() => {
            this.$emit('input', _.omit(this.model, ['rules']))
          }, 200)
        }
      },
      deep: true,
    },
  },
}
</script>
